import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';
import RefreshIcon from '@mui/icons-material/Refresh';
import Tooltip from '@mui/material/Tooltip';

interface Props {
    isRefreshing: boolean,
    lastUpdated: Date | null,
    onRefresh: () => void,
}

export default function RefreshIndicator({ isRefreshing, onRefresh }: Props) {
    return (
        <Tooltip title="Refresh">
            <span>
                <IconButton size="small" onClick={onRefresh} disabled={isRefreshing} aria-label="Refresh">
                    {isRefreshing
                        ? <CircularProgress size={16} thickness={5} />
                        : <RefreshIcon sx={{ fontSize: 18 }} />}
                </IconButton>
            </span>
        </Tooltip>
    );
}
